import "./Loading.scss";

export default function Loading() {
  return (
    <div className="loading">
      <div className="title"></div>
      <div className="items">
        {Array.from(
          window.innerWidth > 1200 ? [1, 2, 3, 4, 5, 6, 7, 8] : [1, 2, 3]
        ).map(() => {
          return <div className="item"></div>;
        })}
      </div>
    </div>
  );
}
